import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var WarningTrOutline = function WarningTrOutline(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V10Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16.5C10.75 17.1904 11.3096 17.75 12 17.75C12.6904 17.75 13.25 17.1904 13.25 16.5C13.25 15.8096 12.6904 15.25 12 15.25C11.3096 15.25 10.75 15.8096 10.75 16.5Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2579 21C21.6048 21 22.4406 19.4894 21.7554 18.2936L13.4975 3.88126C12.8242 2.70625 11.1758 2.70624 10.5025 3.88126L2.24456 18.2936C1.55939 19.4894 2.39524 21 3.74206 21H20.2579ZM19.6554 19C19.8089 19 19.9052 18.8341 19.829 18.7008L12.1736 5.30388C12.0969 5.16952 11.9031 5.16952 11.8264 5.30388L4.17099 18.7008C4.0948 18.8341 4.19107 19 4.34464 19H19.6554Z",
    fill: color
  }));
};

export { WarningTrOutline };
